var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.saved)?_c('div',[_c('form-saved-success',{attrs:{"dis":false,"idParams":_vm.$route.params.id},on:{"RepeatAppeal":_vm.onRepeatAppeal}})],1):_vm._e(),(!_vm.saved)?_c('div',{staticClass:"responsive-box"},[_c('FormViewRun2',{ref:"fvr",attrs:{"edit":false,"formId":_vm.$route.params.id},on:{"saveClick":_vm.saveFunc}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }